import apiClient from "./client";
import type { Announcement, AnnouncementListItem } from "@/types";

/** 获取站点公告列表（公开接口，无需认证） */
export async function getSiteAnnouncements(): Promise<Announcement[]> {
  const { data } = await apiClient.get("/announcements/site");
  return data.data || [];
}

/** 获取站内公告列表（需用户认证，返回已阅标记） */
export async function getUserAnnouncements(): Promise<AnnouncementListItem[]> {
  const { data } = await apiClient.get("/auth/announcements/user");
  return data.data || [];
}

/** 标记站内公告已阅 */
export async function markAnnouncementRead(id: number): Promise<void> {
  await apiClient.post(`/auth/announcements/${id}/read`);
}
